/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Maybe, PointDtoModel } from '@irian-ro/util-functions';
import { JsonApiListResourceMetadataBase } from '@irian-ro/abstract-resource';
import { PackageEventOriginSource } from './package-event-origin-source';
import { PackageSelectionMethodType } from './package-selection-method-type';
import { PackageStateModel } from './package.state.model';
import { PackageStatusType } from './package-status-type';

export interface PackageTrackingModel {
  uuid: string | undefined;

  packageId: Maybe<string> | undefined;
  type: Maybe<string> | undefined;
  shipmentSeries: Maybe<string> | undefined;
  shipmentUuid: Maybe<string> | undefined;
  volume: Maybe<string> | undefined;
  weight: Maybe<string> | undefined;
  height: Maybe<string> | undefined;

  pickupNamedLocationUuid: Maybe<string> | undefined;
  pickupNamedLocationCode: Maybe<string> | undefined;
  pickupNamedLocationLabel: Maybe<string> | undefined;
  pickupStreetName: Maybe<string> | undefined;
  pickupCity: Maybe<string> | undefined;
  pickupCountry: Maybe<string> | undefined;
  pickupDate: Maybe<string> | undefined;

  deliveryNamedLocationUuid: Maybe<string> | undefined;
  deliveryNamedLocationCode: Maybe<string> | undefined;
  deliveryNamedLocationLabel: Maybe<string> | undefined;
  deliveryStreetName: Maybe<string> | undefined;
  deliveryCity: Maybe<string> | undefined;
  deliveryCountry: Maybe<string> | undefined;
  deliveryDate: Maybe<string> | undefined;

  state: PackageStateModel | undefined;

  statusVO:
    | {
        uuid: string | undefined;
        packageStatusType: Maybe<PackageStatusType>;
        timestamp: Maybe<string>;
        namedLocationCode: Maybe<string>;
        namedLocationLabel: Maybe<string>;
        city: Maybe<string>;
      }
    | null
    | undefined;
}

export interface PackageSummaryModel {
  uuid: string | undefined;
  packageId: Maybe<string> | undefined;

  volume: Maybe<string> | undefined;
  weight: Maybe<string> | undefined;
  height: Maybe<string> | undefined;

  deliveryDate: Maybe<string> | undefined;
  deliveryNamedLocationUuid: Maybe<string> | undefined;
  deliveryNamedLocationCode: Maybe<string> | undefined;
  deliveryNamedLocationLabel: Maybe<string> | undefined;
  deliveryStreetName: Maybe<string> | undefined;
  deliveryCity: Maybe<string> | undefined;
  deliveryCountry: Maybe<string> | undefined;

  pickupDate: Maybe<string> | undefined;
  pickupNamedLocationUuid: Maybe<string> | undefined;
  pickupNamedLocationCode: Maybe<string> | undefined;
  pickupNamedLocationLabel: Maybe<string> | undefined;
  pickupStreetName: Maybe<string> | undefined;
  pickupCity: Maybe<string> | undefined;
  pickupCountry: Maybe<string> | undefined;

  shipmentSeries: Maybe<string> | undefined;
  shipmentUuid: Maybe<string> | undefined;

  statusList: Maybe<PackageStatus[]> | undefined;

  statusVO: {
    uuid: string | undefined;
    packageStatusType: Maybe<PackageStatusType>;
    timestamp: Maybe<string>;
    namedLocationCode: Maybe<string>;
    namedLocationLabel: Maybe<string>;
    city: Maybe<string>;
  } | null | undefined
}

export interface PackageStatus {
  packageStatusType: Maybe<string> | undefined;
  timestamp: Maybe<string> | undefined;
  pointVO: Maybe<PointDtoModel> | undefined;
  namedLocationCode: Maybe<string> | undefined;
  namedLocationLabel: Maybe<string> | undefined;
  city: Maybe<string> | undefined;
  originSource: Maybe<PackageEventOriginSource> | undefined;
  packageSelectionMethodType: Maybe<PackageSelectionMethodType> | undefined;
}

export class PackageTrackingMetadataModel  extends JsonApiListResourceMetadataBase {
  packageStatusTypeList: string[] = [];
}
